export const assistantHistoryQueryKey = ["assistant", "history"];
